import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "results-component",
  class: "l-container l-bg-primary"
}
const _hoisted_2 = {
  key: 0,
  class: "m-blockNotice"
}
const _hoisted_3 = {
  key: 1,
  class: "search-results-list"
}
const _hoisted_4 = {
  key: 2,
  class: "search-results-list"
}
const _hoisted_5 = { class: "m-searchList__loadMore" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListItemComponent = _resolveComponent("ListItemComponent")!
  const _component_Artist = _resolveComponent("Artist")!
  const _component_SpinnerComponent = _resolveComponent("SpinnerComponent")!
  const _component_TabsComponent = _resolveComponent("TabsComponent")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TabsComponent, {
      tabs: _ctx.getTabConfiguration(),
      initialTab: _ctx.initialTab,
      modifier: _ctx.modifier,
      onActiveTabChange: _ctx.handleTabChange
    }, {
      [_ctx.tabPanelSlotName(_ctx.activeTab)]: _withCtx(() => [
        (_ctx.noEvents())
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _withDirectives(_createElementVNode("span", null, null, 512), [
                [_directive_translate, {key: _ctx.Translation.No_search_results_notice}]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.results && _ctx.activeTab === _ctx.Tab.Events)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (event, index) => {
                return (_openBlock(), _createBlock(_component_ListItemComponent, {
                  data: _ctx.data,
                  index: index,
                  item: event,
                  listName: _ctx.getListName()
                }, null, 8, ["data", "index", "item", "listName"]))
              }), 256))
            ]))
          : _createCommentVNode("", true),
        (_ctx.artists && _ctx.activeTab === _ctx.Tab.Artists)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artists, (artist) => {
                return (_openBlock(), _createBlock(_component_Artist, {
                  data: _ctx.data,
                  item: artist
                }, null, 8, ["data", "item"]))
              }), 256))
            ]))
          : _createCommentVNode("", true),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_SpinnerComponent, {
              key: 3,
              label: ""
            }))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("button", {
            class: "a-btnCta -action",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args)))
          }, null, 512), [
            [_directive_translate, { key: _ctx.Translation.More_search_results}]
          ])
        ], 512), [
          [_vShow, _ctx.canLoadMore]
        ])
      ]),
      _: 2
    }, 1032, ["tabs", "initialTab", "modifier", "onActiveTabChange"])
  ]))
}